// src/api/offeringsApi.js
import http from './http';

const API_URL = '/api/offerings';

export const getOfferings = () => http.get(API_URL);
export const createOffering = (data) => http.post(API_URL, data);
export const updateOffering = (id, data) => http.put(`${API_URL}/${id}`, data);
export const deleteOffering = (id) => http.delete(`${API_URL}/${id}`);
